(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentServiceItemAccessDialogController', AgentServiceItemAccessDialogController);

    AgentServiceItemAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentServiceItemAccess', 'ServiceItem', 'AgentAccessInfo'];

    function AgentServiceItemAccessDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentServiceItemAccess, ServiceItem, AgentAccessInfo) {
        var vm = this;

        vm.agentServiceItemAccess = entity;
        vm.clear = clear;
        vm.save = save;
        vm.serviceitems = ServiceItem.query();
        vm.agentaccessinfos = AgentAccessInfo.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentServiceItemAccess.id !== null) {
                AgentServiceItemAccess.update(vm.agentServiceItemAccess, onSaveSuccess, onSaveError);
            } else {
                AgentServiceItemAccess.save(vm.agentServiceItemAccess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentServiceItemAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
